import React from "react"
import { Link, graphql, useStaticQuery } from 'gatsby'
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"

export const NoteSideMenu = () => {
  const sideMenu = useStaticQuery (
    graphql`
      query SideMenuQuery {
        allMicrocmsTags(
          filter: {type: {eq: "人気のタグ"}}
        ) {
          edges {
            node {
              referenced_note_tag {
                id
                name
              }
            }
          }
        }
        allMicrocmsNotes(
          limit: 3
          sort: {fields: [publishedAt], order: DESC}
        ) {
          edges {
            node {
              title
              thumbnail {
                url
              }
              notesId
            }
          }
        }
        allMicrocmsNoteMiddleCategories(
          limit: 10
          sort: {fields: publishedAt, order: DESC}
          filter: {display_flag: {eq: true}}
        ) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `
  )
  const popularTags = sideMenu.allMicrocmsTags.edges.map((t) => t.node.referenced_note_tag)
  const hotArticles = sideMenu.allMicrocmsNotes.edges.map((t) => t.node)
  const searchCategories = sideMenu.allMicrocmsNoteMiddleCategories.edges.map((sc) => sc.node)

  return (
      <div className="contents_in_r">
      {
        hotArticles.length &&
        <div className="search_area">
          <div className="search_title">
            注目記事から探す
          </div>
          <div className="search_box_02">
            {hotArticles.map((ha) => (
              <Link to={'/note/' + ha.notesId}>
                <div className="image_flame">
                  <LazyAndPreloadImage imgUrl={ha?.thumbnail?.url ?? ''} alt={"注目の記事"} />
                </div>                
                <p>{ha.title}</p>
              </Link>
            ))}
          </div>
        </div>
      }
        <div className="search_area">
          <div className="search_title">
            テーマから探す
          </div>
          <div className="search_box_01">
            <Link to="/note/case-study">イキイキ・ワクワク事例集</Link>
          </div>
          <div className="search_box_01">
            <Link to="/note/column">ジェイフィールの自由研究</Link>
          </div>
          <div className="search_box_01">
            <Link to="/note/culture">ご機嫌な職場日記</Link>
          </div>
        </div>
      {searchCategories.length && 
        <div className="search_area">
        <div className="search_title">
          カテゴリから探す
        </div>
        <div className="search_box_01">
          {searchCategories.map((sc) => (
            <Link 
              key={sc.id}
              to={`/note/category/${sc.name}`}
            >
            {sc.name}
          </Link>
          ))}
        </div>
      </div>
      }
      {
        popularTags.length &&
        <div className="search_area">
          <div className="search_title">
            人気のタグから探す
          </div>
          <div className="search_box_01">
            {popularTags.map((pt) => (
              <Link 
                key={pt.id}
                to={`/note/tag/${pt.name}`}
              >
                #{pt.name}
              </Link>
            ))}
          </div>
        </div>
      }
    </div>
  )
}

export default NoteSideMenu